export default __webpack_public_path__ + "static/Plots0057-fca047a101d813b29eb4e70ee7a0a788.jpg";